import {AxiosError} from 'axios';
import {POST_SEARCH_REQUEST_OR_TASK_URL} from 'web-library/constants/apiUrls';
import {RequestTaskListingRequest, RequestTaskListingResponse} from 'web-library/models/Request';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: RequestTaskListingResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostSearchRequestOrTask = ({onSuccess, onError}: Input = {}) => {
  const postRequestTaskListing = async (requestData: RequestTaskListingRequest) => {
    const res = await axiosClient.post<RequestTaskListingResponse>(
        POST_SEARCH_REQUEST_OR_TASK_URL(requestData.apiPathParam),
        {
          action: requestData.actionType,
          requestType: requestData.requestType,
          status: requestData.status,
          pending: requestData.isPending,
          request: requestData.isRequest,
        }
    );
    return res.data;
  };

  return useCustomMutation(postRequestTaskListing, {
    onSuccess,
    onError,
  });
};
